export default __webpack_public_path__ + "static/media/tubliBot.0b3716eb.svg";